const embedSVG = (fileName, className) => {
  const svgStr = require("./../../../dist/sprites/" + fileName);
  const svg = new DOMParser().parseFromString(svgStr, 'image/svg+xml').documentElement;
  svg.classList.add(...className.split(" "));
  svg.removeAttribute("stroke");
  return svg.outerHTML;
}

const addSvgToEnd = (text, textClassName, fileName, svgClassName) => {
  var icon = embedSVG(fileName, svgClassName);
  const firstPart = text.split(" ");
  const lastWord = firstPart.pop();

  return "<span class='" + textClassName + "'>" + firstPart.join(" ") + " <nobr>" + lastWord + icon + "</nobr></span>";
}

export { embedSVG, addSvgToEnd };